import React, { FunctionComponent } from "react";
import styles from "./TenantLogo.module.scss";

interface TenantLogoProps {
  /** The logo URL (see `useTenantLogo`). Nothing renders without one. */
  src?: string;
}

/**
 * The tenant logo above a layout's card, aligned with the card's left edge — the job form's header, shared
 * with the geo capture and off-campus request layouts. Place it first in the flex column that holds the card.
 */
const TenantLogo: FunctionComponent<TenantLogoProps> = ({ src }) => (src ? <img src={src} alt="" className={styles.logo} /> : null);

export default TenantLogo;
